import {createStackNavigator} from '@react-navigation/stack';
import i18n from 'i18n-js';
import {useToast} from 'native-base';
import React, {useContext, useEffect} from 'react';
import {Platform} from 'react-native';
import {AuthScreens} from '../auth';
import {AuthContext} from '../lib/authContext';
import {Screens} from '../screens';
import {config} from '../stage.config';
import {Anchor} from './Anchor';

type Props = {};

const Stack = createStackNavigator();

export const Layout: React.FC<Props> = () => {
  const authState = useContext(AuthContext);
  const toast = useToast();

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const params = new URLSearchParams(window.location.search);
    const isFromDesktop = params.get('from_desktop') === '1';
    if (isFromDesktop) {
      toast.show({
        // @ts-ignore
        text: (
          <Anchor style={{color: '#FFF'}} href={`${config.dashboardUrl}?from_mobile=1`}>
            {i18n.t('goToDesktop')}
          </Anchor>
        ),
        buttonText: i18n.t('close'),
        placement: 'top',
        duration: 0
      });
    }
  }, []);

  return (
    <Stack.Navigator>
      {authState.isAuthenticated ? (
        <Stack.Screen
          name="Screens"
          component={Screens}
          options={{
            headerShown: false,
            presentation: 'modal',
            animationTypeForReplace: authState.isAuthenticated ? 'pop' : 'push'
          }}
        />
      ) : (
        <Stack.Screen
          name="AuthScreens"
          component={AuthScreens}
          options={{
            presentation: 'modal',
            headerShown: false
          }}
        />
      )}
    </Stack.Navigator>
  );
};
